import { Component } from '@angular/core';

@Component({
  selector: 'app-policy-payment-view',
  standalone: false,
  templateUrl: './policy-payment-view.component.html',
  styleUrl: './policy-payment-view.component.scss'
})
export class PolicyPaymentViewComponent {

}
